import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-payment-term',
  templateUrl: './delete-payment-term.component.html',
  styleUrls: ['./delete-payment-term.component.css']
})
export class DeletePaymentTermComponent implements OnInit {

  cid: any;
  paymentTermData: any = []
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  singlePaymentTermData: any = []
  deletePaymentTermId:any = ""



  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllPaymentTerm()

  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllPaymentTerm();
  }
  
  onTableSizeChange(event: any): void {
    this.pageNumber = event;
    this.getAllPaymentTerm();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton4")?.click()
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllPaymentTerm(){
    this.generic_service.getAllPaymentTerm().subscribe(
      (response:any)=> {
        console.log(response)
        this.paymentTermData = response.response
        this.totalRecords = response.response.length

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getPaymentTermById(paymentTermId:any){
    
    this.generic_service.getPaymentTermById(paymentTermId).subscribe(
      (response:any)=>{
        console.log(response)
        this.paymentTermData = []
        this.paymentTermData.push(response.response)
        this.deletePaymentTermId = response.response.id

      },
      (err:any)=> {
        console.log(err)
      }
    )
  }



  selectPaymentTerm(id:any){
    this.deletePaymentTermId = id
  }

  deletePaymentTerm(){
    this.generic_service.deletePaymentTerm(this.deletePaymentTermId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllPaymentTerm()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }
 
}
